<ng-template #virtueAlert>
	<div class="modal-header virtue-header">
		<div class="virtue-logo">
			<img src="./assets/images/logo-backup.png" alt="virtue logo"/>
		</div>
	</div>
	<div class="modal-body virtue-body">
		<form id="virtueAlertForm" class="form-horizontal" role="form">
			<div class="form-group margin-t-25 margin-lr-25">
				Please enter a valid Subscription Code. If you don't have one and would like to purchase one, 
				please click <a [routerLink]="['/payment']">here</a> to buy Virtue mSE Subscription Code.
				<!-- please click <a href="mailto: info@virtueanalytics.com?subject=Requesting Virtue mSE Subscription Code">here</a>. -->
			</div>
			<div class="form-group margin-t-25 margin-lr-25">
				<div class="col-lg-12 text-center">
					<button type="button" class="btn page-btn" (click)="hide()">Cancel</button> 
				</div>
			</div>
		</form>
	</div>
</ng-template>
<ng-template #virtuePaymnetAlert>
	<div class="modal-header virtue-header">
		<div class="virtue-logo">
			<img src="./assets/images/logo-backup.png" alt="virtue logo"/>
		</div>
	</div>
	<div class="modal-body virtue-body">
		<form id="virtueAlertForm" class="form-horizontal" role="form">
			<div class="form-group margin-t-25 margin-lr-25">
				Please purchage a subscription code to get full access. If you don't have one and would like to purchase one, 
				please select below Subscription Plan and proceed.
			</div>
			<div class="form-group margin-t-25 margin-lr-25">
				<div class="col-lg-12 text-center">
					<button type="button" class="btn page-btn" (click)="hide()">Cancel</button> 
				</div>
			</div>
		</form>
	</div>
</ng-template>